import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

export interface GetListPayload {
  page?: number;
  offset?: number;
  limit?: number;
  gameTitle?: string;
  isActive?: number;
  hasFreeSpins?: number;
  providerIds?: number[];
}

export const getGamesListService = async (data: GetListPayload) => {
  try {
    const res = await instance.post(apiRoutes.gamesList, data);
    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getGameTypesService = async () => {
  try {
    const res = await instance.get(apiRoutes.gameTypes);
    return res.data?.types || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getGamesByIdsService = async (gameIds: number[]) => {
  try {
    const response = await instance.post(apiRoutes.gamesList, {
      gameIds,
    });

    return response.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
